import { useQuery, useQueryClient } from "react-query";
import AxiosT from "../../setup/setup-axios-bearer";

async function fetchGetSaleFactorsList(page = 1) {
  const res = await AxiosT.get(`/out-warehouse-with-factor?page=${page}`);
  return res.data;
}

export function useGetSaleFactorsList() {
  return useQuery("getSaleFactorsList", fetchGetSaleFactorsList);
}
